interface Props {
  color: string
  name: string
}

export default function MapChip({ color, name }: Props) {
  return (
    <div
      className="grid place-items-center whitespace-nowrap rounded-full px-3 py-1 text-sm font-bold text-white"
      style={{ backgroundColor: color }}>
      {name}
    </div>
  )
}
